import { Field, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class CrudSubscriptionResponseDto {
  @Field()
  status!: 'succeeded' | 'requires_action' | string

  @Field({ nullable: true })
  clientSecret?: string

  @Field({ nullable: true })
  actionUrl?: string

  @Field({ nullable: true })
  actionUrlType?: string
}
